import { gql } from '@apollo/client';

export const CREATE_FEEDBACK = gql`
  mutation createFeedback($input: CreateFeedbackInput!) {
    createFeedback(input: $input) {
      status
    }
  }
`;
